import functionsServices from '../services/FunctionsServices'
import formValidation from '../validation/FormValidation'

const getSelectsCboLogic = async (id, type) => {
  const dataResp = await functionsServices.getSelectsCbo(id, type)
  return dataResp
}

const sendRequest = async (formData) => {
  const dataSave = {
    name: formData.name.value,

    email: formData.email.value,

    phone: formData.phone.value,

    subject: formData.subject.value,

    asunto: formData.asunto.value
  }

  const validation = formValidation.ContactValidation(dataSave)

  let dataResp = validation

  if (!validation.error) {
    dataResp = await functionsServices.sendRequest(dataSave)
  }

  return dataResp
}

const saveRequestTestLogic = async (dataSave) => {
  const validation = formValidation.FormValidation(dataSave)

  if (validation.error) {
    return validation
  }

  const dataResp = await functionsServices.saveRequestTest(dataSave)

  return dataResp
}

const getSelectsTipoNegocio = async () => {
  const dataResp = await functionsServices.getSelectsTipoNegocio()
  return dataResp
}

const getSelectTier = async () => {
  const dataResp = await functionsServices.getSelectTier()
  return dataResp
}

const functionsLogic = {
  sendRequest,
  getSelectsCboLogic,
  saveRequestTestLogic,
  getSelectsTipoNegocio,
  getSelectTier
}

export default functionsLogic
